"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = $axios;
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _index = _interopRequireDefault(require("@/lang/index"));
function $axios(options) {
  return new Promise(function (resolve, reject) {
    var instance = _axios.default.create({
      baseURL: process.env.VUE_APP_BASE_API,
      timeout: 50000,
      headers: {}
    });

    // request 拦截器
    instance.interceptors.request.use(function (config) {
      return config;
    }, function (error) {
      // do something with request error
      console.log('request error----', error); // for debug

      return Promise.reject(error);
    });

    // response interceptor
    instance.interceptors.response.use(function (response) {
      // console.log('response---', response)
      var res = response.data;
      return res;
    }, function (err) {
      console.log('response err---------' + err); // for debug

      if (_axios.default.isCancel(err)) {
        return Promise.reject(err);
      }
      if (err && err.response) {
        switch (err.response.status) {
          case 400:
            err.message = _index.default.t('errorMsg.400');
            break;
          case 401:
            err.message = _index.default.t('errorMsg.401');
            break;
          case 403:
            err.message = _index.default.t('errorMsg.403');
            break;
          case 404:
            // err.message = `请求地址出错: ${err.response.config.url}`
            err.message = _index.default.t('errorMsg.404');
            break;
          case 408:
            err.message = _index.default.t('errorMsg.408');
            break;
          case 500:
            err.message = _index.default.t('errorMsg.500');
            break;
          case 501:
            err.message = _index.default.t('errorMsg.501');
            break;
          case 502:
            err.message = _index.default.t('errorMsg.502');
            break;
          case 503:
            err.message = _index.default.t('errorMsg.503');
            break;
          case 504:
            err.message = _index.default.t('errorMsg.504');
            break;
          case 505:
            err.message = _index.default.t('errorMsg.505');
            break;
          default:
        }
      }

      // 超时
      if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
        err.message = _index.default.t('errorMsg.timeout');
      }
      (0, _elementUi.Message)({
        message: err.message,
        type: 'error',
        duration: 1.5 * 1000
      });
      return Promise.reject(err);
    });

    // 请求处理
    instance(options).then(function (res) {
      resolve(res);
      return false;
    }).catch(function (error) {
      console.log('instance error-----', error);
      reject(error);
    });
  });
}